export default __webpack_public_path__ + "static/media/tempo-solar-bg.5db9980a.jpg";